import "../InputNumber.css";
import { jsx } from "react/jsx-runtime";
import { InputNumber as InputNumber$1 } from "antd";
import { forwardRef } from "react";
import { useInputNumberEscape } from "./internal/useInputEscape.js";
import { useTheme } from "./Theme/UI.js";
import "./Theme/themeUtils.js";
import "./Theme/themes.js";
const base = "InputNumber_base_62e41";
const css = {
  base
};
const InputNumber = forwardRef(
  ({ ...props }, ref) => {
    const { onFocus, onBlur, inputRef } = useInputNumberEscape(ref);
    const {
      themeSettings: { className: themeClass }
    } = useTheme();
    return /* @__PURE__ */ jsx(
      InputNumber$1,
      {
        ...props,
        className: [props.className, themeClass, css.base].join(" "),
        ref: inputRef,
        onBlur,
        onFocus
      }
    );
  }
);
export {
  InputNumber as default
};
